import { combineReducers } from 'redux';
import { paycodes } from '~/apps/support/reducers/paycodes';
import { appRoutes } from './routes';

export const initReducers = () => {
  return {
    support: combineReducers({
      paycodes,
    })
  };
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
};
